import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import Cookies from "js-cookie";
import Config from "../Config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useAuthHandling } from '../useAuthhandling';
import { FaSearch } from 'react-icons/fa';
import Nodatafound from "../Nodatafound";

function CustomerSus() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  const [search, setSearch] = useState('');

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }

  const [customerdata, setCustomer] = useState([]);
  const[paginate,setPaginate]=useState('');
  const [pagenum,setPagenum]=useState(1);
  const[pageindex,setPageindex]=useState(1);


  // const getinfo = async (e) => {
  //   const res = await fetch(
  //     `${Config.apiurl}/api/v1/crm/customer/get-suspended-customers?page=1`,
  //     {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${Cookies.get("a_token")}`,
  //       },
  //     }
  //   );
  //   if (res.status === 200) {
  //     const data = await res.json();

  //     setCustomer(data.data[0].data);
  //     setPaginate(data.data[0].total_pages);
  //   }
  //   else if(res.status === 401){
  //     handleUnauthorized();
  //     getinfo();
  //   }
  //   else {
  //     alert("error");

  //   }
  // };
  useEffect(() => {
    // getinfo();
  }, []);

  const deletecustomer = async (id) => {
    // const response = await fetch(
    //   `${Config.apiurl}/api/v1/crm/customer/delete-customer/${id}`,
    //   {
    //     method: "PUT",
    //     headers: {
    //       Authorization: `Bearer ${Cookies.get("a_token")}`,
    //     },
    //   }
    // );


     const response = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/un-suspend-customer/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (response.status === 200) {
      const deletedata = await response.json();

      toast.success("Customer suspension removed", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handlePageClick(pagenum);
    } 
    else if(response.status === 401){
      handleUnauthorized();
      deletecustomer();
    }
    else {
    console.log("error");
    }
  };

  const fetchComments = async (currentPage) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/get-suspended-customers?page=${currentPage}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {

    const data = await res.json();
    return data.data[0].data;
  }
  else if(res.status === 401){
    handleUnauthorized();
    fetchComments(currentPage)
  }
  };

  const handlePageClick = async (data) => {
    if(data===1){
      setPageindex(1);

      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setCustomer(commentsFormServer);
    }
    else{
    let currentPage = data.selected + 1;
    setPageindex(currentPage);

    setPagenum(data);
    const commentsFormServer = await fetchComments(currentPage);

    setCustomer(commentsFormServer);
    }
    
  };
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Customer List</h4>
                    <div className="table-responsive pt-3">
                    {customerdata.length>0?
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sl No</th>
                            <th>Name</th>
                            <th>E-mail</th>
                            <th>Contact Number</th>
                           
                            <th>Unsuspend</th>
                          </tr>
                        </thead>
                        <tbody>
                         
                          {customerdata.map((element, i) => {
                            return (
                              <>
                                <tr key={i}>
                                  <th scope="row">{pageindex===1 ? i + 1: (pageindex-1) * 10 + i + 1}</th>
                                  <td>{element.name}</td>
                                  <td>{element.email}</td>
                                  <td>{element.mobile}</td>
                                 
                                  <td>
                                    <button
                                      onClick={() =>
                                        deletecustomer(element._id)
                                      }
                                      className="unsuspend_btn"
                                    >
                                     Unsuspend
                                    </button>
                                   
                                    <ToastContainer />
                                  </td>
                                </tr>
                              </>
                            );
                          })
                          }
                        </tbody>
                      </table>
                      :
                     <Nodatafound/>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {paginate > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={paginate}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}

          </div>
         
        </div>
      </div>
    </div>
  );
}

export default CustomerSus;
